import React from "react";
import { func } from "prop-types";
import I18n from "pages/_components/I18n";
import { today, date7DaysBefore, date7DaysAfter } from "pages/deposits/utils";
import FilterForm from "../../ManagementCedip/components/FilterForm";

const GridSideBarForm = ({ closeSidebar }) => {
    const initialValues = {
        createdRange: [date7DaysBefore, today],
        expiredRange: [today, date7DaysAfter],
    };

    return (
        <div className="container full-width">
            <I18n id="cedips.filter" component="h2" />
            <FilterForm customValues={initialValues} closeSidebar={closeSidebar} />
        </div>
    );
};

GridSideBarForm.propTypes = {
    closeSidebar: func.isRequired,
};

export default GridSideBarForm;
